import {useInRouterContext,useNavigate} from 'react-router-dom';
import { CheckCircle2, CircleAlert, X } from "lucide-react";
import { useCallback, useEffect, useMemo, useRef, useState, type ReactNode } from "react";
import { ToastContext, type ToastItem, type ToastTone, type ToastOptions } from "./toast-context";
import { aiDisplayText } from "../lib/ai-display";


export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);
  const showToast = useCallback((message: string, tone: ToastTone = "success", options:ToastOptions = {}) => {
    const id = Date.now() + Math.random();
    setItems((current) => [...current, { id, message, tone, ...options }]);

  }, []);
  const value = useMemo(() => ({ showToast }), [showToast]);
  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toast-region" aria-live="polite">
        {items.map((item) => (
          <ToastNotice key={item.id} item={item} onDismiss={()=>setItems(current=>current.filter(toast=>toast.id!==item.id))}/>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

function ToastNotice({item,onDismiss}:{item:ToastItem;onDismiss:()=>void}) {
  const [paused,setPaused]=useState(false);
  const inRouter=useInRouterContext();
  const remaining=useRef(item.duration??3600);
  const dismiss=useRef(onDismiss);dismiss.current=onDismiss;
  useEffect(()=>{
    if(paused)return;
    const started=Date.now();const timer=window.setTimeout(()=>dismiss.current(),remaining.current);
    return ()=>{window.clearTimeout(timer);remaining.current=Math.max(0,remaining.current-(Date.now()-started));};
  },[paused]);
  return <div className={`toast toast--${item.tone}`} onMouseEnter={()=>{if(item.actionLabel)setPaused(true);}} onMouseLeave={()=>setPaused(false)}
    onFocus={()=>{if(item.actionLabel)setPaused(true);}} onBlur={event=>{if(!event.currentTarget.contains(event.relatedTarget))setPaused(false);}}>
    {item.tone==='success'?<CheckCircle2/>:<CircleAlert/>}<span>{aiDisplayText(item.message)}</span>
    {item.actionLabel&&(inRouter&&item.actionHref?<RouterToastAction item={item} onDismiss={onDismiss}/>:<button type="button" onClick={()=>{item.onAction?.();if(item.actionHref)window.location.assign(item.actionHref);onDismiss();}}>{item.actionLabel}</button>)}
    <button type="button" aria-label="关闭提示" onClick={onDismiss}><X/></button>
  </div>;
}

function RouterToastAction({item,onDismiss}:{item:ToastItem;onDismiss:()=>void}) {
  const navigate=useNavigate();
  return <button type="button" onClick={()=>{item.onAction?.();navigate(item.actionHref!);onDismiss();}}>{item.actionLabel}</button>;
}
